export const patientExtractData = {
  firstName: 'Anna',
  lastName: 'Moris',
  patientId: 200,
  userId: 547,
  gender: 1,
  birthDate: '1990-01-30',
  weight: {
    current: {
      value: '132',
      source: 'Provider',
    },
    highestWeight: {
      value: '158',
      source: 'Patient',
    },
    lowestWeight: {
      value: '100',
      source: 'Patient',
    },
    heightFromMetaData: '7\'10"',
    bmiFromMetaData: 10.502037120869172,
  },
  firstWeightValue: {
    value: '132.00',
    source: 'Patient',
  },
  structuredFood: {
    '2023-03-02': {
      Breakfast: [
        {
          id: 1577132,
          name: 'caesar salad',
          date: '2023-03-02',
          time: '21:20:30',
          type: 'Breakfast',
          quantity: '1',
          unit: 'salad ',
        },
        {
          id: 1577460,
          name: 'Coffee with Milk',
          date: '2023-03-02',
          time: null,
          type: 'Breakfast',
          quantity: '2',
          unit: 'serving',
        },
      ],
    },
    '2023-03-04': {
      Dinner: [
        {
          id: 1577131,
          name: 'lemonade',
          date: '2023-03-04',
          time: '21:20:30',
          type: 'Dinner',
          quantity: '1',
          unit: 'cup 8 fl oz',
        },
      ],
      Breakfast: [
        {
          id: 1577129,
          name: 'sauce',
          date: '2023-03-04',
          time: '21:20:30',
          type: 'Breakfast',
          quantity: '0.5',
          unit: 'cup',
        },
      ],
      Lunch: [
        {
          id: 1577130,
          name: 'roast beef sandwich',
          date: '2023-03-04',
          time: '21:20:30',
          type: 'Lunch',
          quantity: '1',
          unit: 'sandwich',
        },
      ],
    },
  },
  vitals: [
    {
      id: 1326,
      temperatureDataId: null,
      bloodPressureDataId: 116,
      pulseRateDataId: 100,
      temperature: null,
      waistCircumference: 22,
      priority: 1,
      dateTime: '2021-12-07T13:24:09.000Z',
      userId: 547,
      updatedAt: '2021-12-07T13:24:38.489Z',
      weight: '132',
      systolicBloodPressure: '169',
      diastolicBloodPressure: '80',
      pulse: 122,
      bloodPressure: '169 / 80',
      bmi: 30,
      height: '7\'10"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 1207,
      temperatureDataId: null,
      bloodPressureDataId: 75,
      pulseRateDataId: 61,
      temperature: null,
      waistCircumference: null,
      priority: 1,
      dateTime: '2021-11-12T14:11:50.000Z',
      userId: 547,
      updatedAt: '2021-11-12T14:12:09.361Z',
      weight: '132',
      systolicBloodPressure: '110',
      diastolicBloodPressure: '70',
      pulse: 129,
      bloodPressure: '110 / 70',
      bmi: null,
      height: '7\'10"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 1202,
      temperatureDataId: null,
      bloodPressureDataId: null,
      pulseRateDataId: null,
      temperature: null,
      waistCircumference: null,
      priority: 1,
      dateTime: '2021-11-12T10:32:07.000Z',
      userId: 547,
      updatedAt: '2021-11-12T10:32:12.729Z',
      weight: '122',
      systolicBloodPressure: null,
      diastolicBloodPressure: null,
      pulse: '',
      bloodPressure: '  ',
      bmi: null,
      height: '7\'10"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 1201,
      temperatureDataId: null,
      bloodPressureDataId: 70,
      pulseRateDataId: 57,
      temperature: null,
      waistCircumference: null,
      priority: 3,
      dateTime: '2021-11-12T10:29:49.000Z',
      userId: 547,
      updatedAt: '2021-11-12T10:31:33.776Z',
      weight: '132',
      systolicBloodPressure: '110',
      diastolicBloodPressure: '69',
      pulse: 125,
      bloodPressure: '110 / 69',
      bmi: null,
      height: '7\'10"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 1196,
      temperatureDataId: null,
      bloodPressureDataId: 67,
      pulseRateDataId: 56,
      temperature: null,
      waistCircumference: null,
      priority: 3,
      dateTime: '2021-11-11T08:54:49.000Z',
      userId: 547,
      updatedAt: '2021-11-12T08:56:38.229Z',
      weight: '132',
      systolicBloodPressure: '110',
      diastolicBloodPressure: '68',
      pulse: 120,
      bloodPressure: '110 / 68',
      bmi: null,
      height: '7\'10"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 1205,
      temperatureDataId: null,
      bloodPressureDataId: 73,
      pulseRateDataId: null,
      temperature: null,
      waistCircumference: null,
      priority: 1,
      dateTime: '2021-10-29T12:26:26.000Z',
      userId: 547,
      updatedAt: '2021-11-12T12:26:47.351Z',
      weight: '132',
      systolicBloodPressure: '110',
      diastolicBloodPressure: '63',
      pulse: '',
      bloodPressure: '110 / 63',
      bmi: null,
      height: '7\'10"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 1208,
      temperatureDataId: null,
      bloodPressureDataId: 76,
      pulseRateDataId: 62,
      temperature: null,
      waistCircumference: null,
      priority: 1,
      dateTime: '2021-10-28T14:15:02.000Z',
      userId: 547,
      updatedAt: '2021-11-12T14:15:34.374Z',
      weight: '135',
      systolicBloodPressure: '110',
      diastolicBloodPressure: '70',
      pulse: 122,
      bloodPressure: '110 / 70',
      bmi: null,
      height: '7\'10"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 1204,
      temperatureDataId: null,
      bloodPressureDataId: 72,
      pulseRateDataId: 59,
      temperature: null,
      waistCircumference: null,
      priority: 1,
      dateTime: '2021-10-12T12:25:32.000Z',
      userId: 547,
      updatedAt: '2021-11-12T12:25:58.519Z',
      weight: '130',
      systolicBloodPressure: '110',
      diastolicBloodPressure: '60',
      pulse: 121,
      bloodPressure: '110 / 60',
      bmi: null,
      height: '7\'10"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 918,
      temperatureDataId: null,
      bloodPressureDataId: null,
      pulseRateDataId: null,
      temperature: null,
      waistCircumference: null,
      priority: 1,
      dateTime: '2021-09-06T14:20:47.632Z',
      userId: 547,
      updatedAt: '2021-09-14T09:21:33.391Z',
      weight: '223.00',
      systolicBloodPressure: null,
      diastolicBloodPressure: null,
      pulse: '',
      bloodPressure: '  ',
      bmi: null,
      height: '7\'10"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 860,
      temperatureDataId: null,
      bloodPressureDataId: null,
      pulseRateDataId: null,
      temperature: null,
      waistCircumference: null,
      priority: 1,
      dateTime: '2021-09-01T12:40:53.022Z',
      userId: 547,
      updatedAt: '2021-08-24T12:41:00.048Z',
      weight: '129',
      systolicBloodPressure: null,
      diastolicBloodPressure: null,
      pulse: '',
      bloodPressure: '  ',
      bmi: null,
      height: '7\'10"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 783,
      temperatureDataId: 38,
      bloodPressureDataId: null,
      pulseRateDataId: null,
      temperature: '98',
      waistCircumference: null,
      priority: 1,
      dateTime: '2021-08-03T15:40:27.137Z',
      userId: 547,
      updatedAt: '2021-08-03T15:43:26.529Z',
      weight: '330',
      systolicBloodPressure: null,
      diastolicBloodPressure: null,
      pulse: '',
      bloodPressure: '  ',
      bmi: null,
      height: '7\'10"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 781,
      temperatureDataId: null,
      bloodPressureDataId: null,
      pulseRateDataId: null,
      temperature: null,
      waistCircumference: null,
      priority: 1,
      dateTime: '2021-08-03T15:38:04.456Z',
      userId: 547,
      updatedAt: '2021-08-03T15:38:22.373Z',
      weight: '123',
      systolicBloodPressure: null,
      diastolicBloodPressure: null,
      pulse: '',
      bloodPressure: '  ',
      bmi: null,
      height: '52\'10"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 780,
      temperatureDataId: 37,
      bloodPressureDataId: null,
      pulseRateDataId: null,
      temperature: '100.00',
      waistCircumference: null,
      priority: 4,
      dateTime: '2021-08-03T15:36:04.533Z',
      userId: 547,
      updatedAt: '2021-08-03T15:36:27.804Z',
      weight: '300.00',
      systolicBloodPressure: null,
      diastolicBloodPressure: null,
      pulse: '',
      bloodPressure: '  ',
      bmi: null,
      height: '3\'0"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 245,
      temperatureDataId: 34,
      bloodPressureDataId: null,
      pulseRateDataId: null,
      temperature: '96.88',
      waistCircumference: '128.91',
      priority: 2,
      dateTime: '2021-08-03T15:32:40.464Z',
      userId: 547,
      updatedAt: '2021-04-08T10:47:15.713Z',
      weight: '170.13',
      systolicBloodPressure: null,
      diastolicBloodPressure: null,
      pulse: '',
      bloodPressure: '  ',
      bmi: null,
      height: '0\'10"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 777,
      temperatureDataId: 35,
      bloodPressureDataId: null,
      pulseRateDataId: null,
      temperature: '97.88',
      waistCircumference: null,
      priority: 1,
      dateTime: '2021-08-03T15:29:13.967Z',
      userId: 547,
      updatedAt: '2021-08-03T15:29:31.745Z',
      weight: '154.32',
      systolicBloodPressure: null,
      diastolicBloodPressure: null,
      pulse: '',
      bloodPressure: '  ',
      bmi: null,
      height: '2\'0"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
    {
      id: 778,
      temperatureDataId: 33,
      bloodPressureDataId: null,
      pulseRateDataId: null,
      temperature: '98.50',
      waistCircumference: null,
      priority: 2,
      dateTime: '2021-08-02T15:31:42.161Z',
      userId: 547,
      updatedAt: '2021-08-03T15:32:11.618Z',
      weight: '200.00',
      systolicBloodPressure: null,
      diastolicBloodPressure: null,
      pulse: '',
      bloodPressure: '  ',
      bmi: null,
      height: '2\'4"',
      averageBloodPressure: '118 / 69',
      averagePulse: 123.16666666666667,
    },
  ],
  activityData: {
    activityDays: 1,
    activityTime: 90,
    activityTypes: 'Upper body workout, Bicycling, Walking.',
    highIntensityUsed: 'Moderate',
  },
  medicalData: {
    diagnoses: [
      {
        name: 'Apnea',
        source: 'Patient',
        date: '06/21/2021',
      },
      {
        name: 'Acid Reflux',
        source: 'Patient',
        date: '01/25/2022',
      },
    ],
    medications: [
      {
        name: 'Linagliptin Premix',
        source: 'Patient',
        date: '05/27/2021',
        startDate: '05/27/2021',
        dosage: { Type: 'Tablet' },
        route: 'ORAL',
        frequency: { Period: 'After Meals', Unit: '1', Timing: 'Twice a day' },
        adherence7Days: 0,
        adherence30Days: 0,
        adherence90Days: 0,
      },
    ],
    aomHistory: [
      {
        name: 'Bupropion Hydrochloride IR 100mg tab',
        source: 'Provider',
        endDate: '10/25/2022',
        startDate: '10/10/2022',
        medicationNameFormatted: 'Bupropion Hydrochloride IR 100mg tab',
        reasonForDiscontinuing: 'Adverse reaction',
      },
      {
        name: 'Bupropion Hydrochloride IR 100mg tab',
        source: 'Provider',
        endDate: null,
        startDate: null,
        medicationNameFormatted: 'Bupropion Hydrochloride IR 100mg tab',
        reasonForDiscontinuing: null,
      },
    ],
  },
  historyData: {
    weightHistory: {
      'Weight Gain Challenges': 'Feeling too restricted by a diet or exercise program',
      'Weight Gain Events': 'Job/school',
      'Lifestyle schedule': 'Work from home,Long hours,Stressful',
      lowestWeight: '225',
      Date_LowWeightYear: '2015',
      'Weight Loss Reason': 'To look or feel better',
      height: 65,
      highestWeight: '275',
      Date_HighWeightYear: '2020',
      bmiLowestWeight: 37.437869822485204,
      bmiHigestWeight: 45.75739644970414,
      'Confirmed insulin resistant diagnosis': 'Prediabetes,Family history of type 2 diabetes, prediabetes, insulin resistance, PCOS,t',
    },
    dietaryHistory: {
      'Biggest Daily Meal': 'Breakfast',
      'Eating Triggers': 'Anxiety',
      'After dinner eating': '26-50%',
      'Eating disorder': 'Yes',
      'Dietary Strategies': 'Low fat',
      'Sugary Foods': 'Candy',
      'Number of steps': '2-5,000 ',
      'Activity level': 'Lightly active (e.g., some light activity in daily life)',
      Supplements: 'Pemetrexed disodium,Original Antiseptic',
    },
    socialHistory: {
      'Alcohol use': 'Yes',
      'Cigarette use': 'No',
    },
    sleepHistory: {
      regular_sleep_hours: '8',
      Sleep_Tired: 'No',
    },
    allergyHistory: [
      {
        name: 'Novocaine',
        source: '4',
        date: '2022-01-25T13:19:19.420Z',
        updatedAt: '12/02/2022',
      },
      {
        name: 'Metformin hydrochloride',
        source: '4',
        date: '2022-11-02T13:34:10.527Z',
        updatedAt: '12/02/2022',
      },
    ],
  },
  nutritionFacts: {},
  nutritionGoals: [],
  vitalsWithTimeframe: {
    systolic: {
      bpAverage: 123,
      bpRecent: 130,
      bpMaxValue: 130,
      bpMinValue: 110,
      bpMaxDate: '2023-07-12T12:47:23.000Z',
      bpMinDate: '2023-06-01T12:37:02.000Z',
      bpSource: 1,
    },
    diastolic: {
      bpAverage: 93,
      bpRecent: 100,
      bpMaxValue: 100,
      bpMinValue: 80,
    },
    pulse: {
      pulseAverage: 115,
      pulseRecent: 120,
      pulseMaxValue: 120,
      pulseMinValue: 110,
      pulseMaxDate: '2023-07-14T13:05:00.000Z',
      pulseMinDate: '2023-07-12T12:47:23.000Z',
      pulseSource: 1,
    },
  },
  foodDataWithTimeFrame: {
    foodLogs: {
      breakfast: [
        {
          name: 'Coffee with Milk',
          type: 'Breakfast',
          date: '2022-10-26',
        },
        {
          name: 'diet coke',
          type: 'Breakfast',
          date: '2022-03-15',
        },
      ],
      breakfastTimeFrame: {
        maxDate: '2022-10-26T00:00:00.000Z',
        minDate: '2022-03-15T00:00:00.000Z',
      },
      lunch: [
        {
          name: 'Coffee with Milk',
          type: 'Lunch',
          date: '2022-10-26',
        },
        {
          name: 'shake',
          type: 'Lunch',
          date: '2022-03-14',
        },
      ],
      lunchTimeFrame: {
        maxDate: '2022-10-26T00:00:00.000Z',
        minDate: '2022-03-14T00:00:00.000Z',
      },
      dinner: [
        {
          name: 'sausage pizza',
          type: 'Dinner',
          date: '2022-10-26',
        },
        {
          name: 'protein shake',
          type: 'Dinner',
          date: '2022-03-11',
        },
      ],
      dinnerTimeFrame: {
        maxDate: '2022-10-26T00:00:00.000Z',
        minDate: '2022-03-11T00:00:00.000Z',
      },
      snack: [
        {
          name: 'breakfast taco',
          type: 'Snack',
          date: '2022-10-26',
        },
        {
          name: 'water',
          type: 'Snack',
          date: '2022-03-11',
        },
      ],
      snackTimeFrame: {
        maxDate: '2022-10-26T00:00:00.000Z',
        minDate: '2022-03-11T00:00:00.000Z',
      },
    },
  },
  appetiteState: 'Sometimes',
  drinkAndEatPattern: 'Diet Soda',
  afterDinnerCalories: '0-25%',
  sleep: {
    apnea: 'Yes - inconsistent but most nights',
    daytimeSleepiness: 'No',
    insomnia: 'No',
    osa: 'No',
    snoring: 'Yes - Severe',
    treatingApnea: null,
  },
  trackerInfo: [
    {
      name: 'Bicycling',
      duration: 40,
      intensity: '1',
      date: '2023-05-16T07:25:54.163Z',
      caloriesBurned: 317.33,
    },
    {
      name: 'Running',
      duration: 30,
      intensity: '2',
      date: '2023-04-16T07:25:54.163Z',
      caloriesBurned: 343,
    },
    {
      name: 'Football',
      duration: 30,
      intensity: '2',
      date: '2023-03-16T07:25:54.163Z',
      caloriesBurned: 28,
    },
  ],
  food: {
    grazing: 'Always',
    cravings: 'Never',
    binge: 'Sometimes',
  },
  social: {
    drinkingLess: 'Yes',
  },
  allergicMedications: ['DOMETUSS', 'Antiseptic Mouth Rinse'],
};
